import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import compose from 'lodash.flowright';
import { connect } from 'react-redux';

import { mapProps } from '../../../../../../../util/hocs';
import { setActiveIdentity as setActiveIdentityAction } from '../../../../../../../services/checkout/redux/checkoutActions';
import { setPendingPurchasingOption as setPendingPurchaseOptionAction } from '../../../../../redux/memberships/membershipsActions';
import getSimplifiedAlbumMembershipGroup from '../../graphql/queries/getSimplifiedAlbumMembershipGroup';
import ScrollableDiv from '../../../../../../../components/global/ScrollableDiv';
import IdentitySelectorAvatar from './IdentitySelectorAvatar';
import Placeholder from './Placeholder';
import PhotoFilterDropdown from '../PhotoFilterDropdown';
import useFirstAvailableIdentity from '../../../../../../pro/views/HierarchyItem/All/components/AllPhotos/hooks/useFirstAvailableIdentity';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  activeIdentity: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  identities: PropTypes.arrayOf(
    PropTypes.shape({
      identity: PropTypes.shape({
        id: PropTypes.string.isRequired,
      }),
      matched_photos_extended: PropTypes.shape({
        total: PropTypes.number,
      }),
    }),
  ),
  albumMembershipGroup: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  setActiveIdentity: PropTypes.func.isRequired,
  albumMembershipGroupId: PropTypes.string,
};

const IdentitySelector = ({
  history,
  location,
  identities,
  activeIdentity,
  setActiveIdentity,
  albumMembershipGroup,
  albumMembershipGroupId,
}) => {
  const classes = classNames({
    'identity-selector': true,
  });
  useFirstAvailableIdentity({ albumMembershipGroupId });
  const isMatchesUrl =
    location?.pathname === `/consumer/matches/${albumMembershipGroupId}`;

  if (!activeIdentity) {
    return <Placeholder />;
  }

  if (albumMembershipGroup?.matched_photos_extended?.total === 0) {
    return null;
  }

  return (
    <div className={classes}>
      <ScrollableDiv orientation="horizontal">
        <div className="identity-selector-container">
          {(identities ?? []).map(identity => {
            return (
              <IdentitySelectorAvatar
                key={identity.identity.id}
                identity={identity.identity}
                onClick={() => {
                  setActiveIdentity(identity.identity);
                  if (!isMatchesUrl && history) {
                    history.push(
                      `/consumer/matches/${albumMembershipGroupId}/`,
                    );
                  }
                }}
                isActive={identity.identity.id === activeIdentity?.id}
                matchesCount={identity.matched_photos_extended.total}
                isShared={!identity.is_owner}
              />
            );
          })}
        </div>
      </ScrollableDiv>
      <PhotoFilterDropdown />
    </div>
  );
};

IdentitySelector.propTypes = propTypes;

export { IdentitySelector as IdentitySelectorComponent };

const mapStateToProps = ({ checkout }) => ({
  activeIdentity: checkout.activeIdentity,
});

const mapDispatchToProps = {
  setActiveIdentity: setActiveIdentityAction,
  setPendingPurchaseOption: setPendingPurchaseOptionAction,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  mapProps(props => ({
    ...props,
    albumMembershipGroupId: props.match.params.albumMembershipGroupId,
  })),
  getSimplifiedAlbumMembershipGroup,
  mapProps(({ data, ...props }) => ({
    ...props,
    identities: data?.albumMembershipGroup?.identities,
    albumMembershipGroup: data?.albumMembershipGroup,
  })),
)(IdentitySelector);
